import { z } from '@bonanza-social/toolkit/api';
import { AsyncThunk, DataState, State } from '@bonanza-social/toolkit/state';
import { HistoryRequestSchema } from '../../api/HistoryService.schemas';

export type HistoryState<T> = {
  data?: T;
  dataState: DataState;
  lastTimestamp?: string;
};

export type HistoryRequest = z.infer<typeof HistoryRequestSchema>;

export type FetchHistoryParams = {
  startDate: HistoryRequest['startDate'];
  pageNumber?: HistoryRequest['pageNumber'];
  replace: boolean;
};

export enum HistoryType {
  Transactions,
  Gaming,
  CoinGaming,
  Sessions,
}

export type HistoryStateFunctions = {
  hasNextPageSelector: (state: State) => boolean | undefined;
  pageNumberSelector: (state: State) => number | undefined;
  itemsSelector: (state: State, timestamp: string) => any[];
  lastTimestampSelector: (state: State) => string | undefined;
  dataStateSelector: (state: State) => DataState;
  fetchHistory: AsyncThunk<any, FetchHistoryParams, object>;
  resetLastTimestamp: () => { type: string };
  hasPaymentMethodsAwaitingDocumentReview?: (
    state: State,
  ) => boolean | undefined;
  hasPaymentMethodsAwaitingDocumentVerification?: (
    state: State,
  ) => boolean | undefined;
};
